import { round } from './math';

export abstract class RGB
{
  R = 0;
  G = 0;
  B = 0;
}

export abstract class RGBA extends RGB
{
  A = 1;

  static toString(rgba: RGBA): string
  {
    return `rgba(${rgba.R}, ${rgba.G}, ${rgba.B}, ${rgba.A})`;
  }
}

export function getIntermediateColor(params: {
  startColor: RGBA;
  endColor: RGBA;
  ratio: number;
}): RGBA
{
  const { startColor, endColor, ratio } = params;

  const returnColor = {
    R: startColor.R,
    G: startColor.G,
    B: startColor.B,
    A: startColor.A ?? 1,
  };

  const deltaColor = {
    R: (endColor.R - startColor.R) * (1 - ratio),
    G: (endColor.G - startColor.G) * (1 - ratio),
    B: (endColor.B - startColor.B) * (1 - ratio),
    A: (endColor.A - startColor.A) * (1 - ratio),
  };

  returnColor.R += round(deltaColor.R);
  returnColor.G += round(deltaColor.G);
  returnColor.B += round(deltaColor.B);
  returnColor.A += round(deltaColor.A);

  return returnColor;
}
